module.exports = __webpack_public_path__ + "img/sack-solid.2e9cee0c.svg";